import { EventEmitter, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { OptionalAdministrativeFeeDto } from '../models/launcher/optionalAdministrativeFeeDto';
import { CurrentDiscountDto } from '../models/launcher/currentDiscountDto';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private translateService: TranslateService) { }

  // Evento que agregar el rol admin al iniciar la aplicación
  private _initSessionAdminEventEmiter = new BehaviorSubject<boolean>(false);

  initSessionAdmin$ = this._initSessionAdminEventEmiter.asObservable();

  private _numberPageEventEmitter = new EventEmitter<number>();

  private _sizePageEventEmitter = new EventEmitter<number>();

  // Evento encargado de indicar cuando se ha generado el token para habilitar la página
  private _initLoadingInitPage = new BehaviorSubject<boolean>(false);

  // Evento para obtener el listado de las tasas administrativas opcionales devuelto dentro del calculo potencial
  private _initTaxAdminOptionalCalcPotential = new BehaviorSubject<OptionalAdministrativeFeeDto[] | null>(null);

  // Evento para obtener el listado de los descuentos devuelto dentro del calculo potencial
  private _initSelectDiscountCalcPotential = new BehaviorSubject<CurrentDiscountDto [] | null >(null);

  // Evento para saber en cada momento cuando se pulsa el boton del modal para visualizar los descuentos en el lanzador del alta de matrícula
  private _initSelectDiscountModal = new BehaviorSubject<boolean>(false);

  // Setea el rol admin
  setAdminStatus(isAdmin: boolean): void {
    this._initSessionAdminEventEmiter.next(isAdmin);
  }

  isAdmin(): Observable<boolean> {
    return this.initSessionAdmin$.pipe(
      map(isAdmin => isAdmin ? true : false)
    );
  }

  get numberPageEventEmitter() {
    return this._numberPageEventEmitter;
  }

  get sizePageEventEmitter() {
    return this._sizePageEventEmitter;
  }

  changeSize(count: number) {
    this._sizePageEventEmitter.emit(count);
  }
  // Método para emitir un cambio de página
  changePage(page: number): void {
    this._numberPageEventEmitter.emit(page);
  }

  getCurrentLanguage(): string {
    return this.translateService.currentLang || 'es';
  }

  get initLoadingInitPage(): Observable<boolean> {
    return this._initLoadingInitPage.asObservable();
  }

  notifyPageInit(): void {
    this._initLoadingInitPage.next(true);
  }

  controlInput(form: any, field: string): boolean {
    return form.get(field)?.invalid && form.get(field)?.touched
  }
  
  // Setea las tasas admin opcionales
  setInitTaxAdminOptionalCalcPotential(value: OptionalAdministrativeFeeDto[]): void {
    this._initTaxAdminOptionalCalcPotential.next(value);
  }

  // Obtiene las tasas admin opcionales
  get initTaxAdminOptionalCalcPotential(): Observable<any> {
    return this._initTaxAdminOptionalCalcPotential.asObservable();
  }

  // Setea los descuentos
  setInitSelectDiscountCalcPotential(value: CurrentDiscountDto[]): void {
    this._initSelectDiscountCalcPotential.next(value);
  }

  // Obtiene los descuentos
  get initSelectDiscountCalcPotential(): Observable<any> {
    return this._initSelectDiscountCalcPotential.asObservable();
  }

   setInitSelectDiscountModal(isViewDiscount: boolean): void {
    this._initSelectDiscountModal.next(isViewDiscount);
  }

  get initSelectDiscountModal(): Observable<any> {
    return this._initSelectDiscountModal.asObservable();
  }

  /**
   * Función encargada de abrir el modal del spinner
   */
  showSpinnerModal() {
    const spinnerModalElement = document.getElementById('spinner-modal') as HTMLElement;
    if (spinnerModalElement) {
      // Agregamos los elementos a mano para evitar conflicto con bootstrap
      spinnerModalElement.classList.add('show'); // Agrega la clase 'show' para mostrar el modal
      spinnerModalElement.style.display = 'block'; // Block para asegurarnos de que es visible, por defecto, está a none
      document.body.classList.add('modal-open'); // Agrega la clase para evitar el scroll
      const backdrop = document.createElement('div'); // Crea el backdrop
      backdrop.className = 'modal-backdrop fade show'; // Asigna las clases para mostrar el modal
      document.body.appendChild(backdrop); // Agrega el backdrop al cuerpo
    }
  }

  /**
   * Función encargada de cerrar el modal del spinner
   */
  hideSpinnerModal() {
    const spinnerModalElement = document.getElementById('spinner-modal') as HTMLElement;
    if (spinnerModalElement) {
      spinnerModalElement.classList.remove('show'); // Remueve la clase 'show'
      spinnerModalElement.style.display = 'none'; // Oculta el modal
      document.body.classList.remove('modal-open'); // Remueve la clase para permitir el scroll
      const backdrop = document.querySelector('.modal-backdrop'); // Busca el backdrop
      if (backdrop) {
        backdrop.remove(); // Elimina el backdrop
      }
    }
  }

  showDiscountModal() {
    const showDiscountModalElement = document.getElementById('discount-modal') as HTMLElement;
    if (showDiscountModalElement) {
      // Agregamos los elementos a mano para evitar conflicto con bootstrap
      showDiscountModalElement.classList.add('show'); // Agrega la clase 'show' para mostrar el modal
      showDiscountModalElement.style.display = 'block'; // Block para asegurarnos de que es visible, por defecto, está a none
      document.body.classList.add('modal-open'); // Agrega la clase para evitar el scroll
      const backdrop = document.createElement('div'); // Crea el backdrop
      backdrop.className = 'modal-backdrop fade show'; // Asigna las clases para mostrar el modal
      document.body.appendChild(backdrop); // Agrega el backdrop al cuerpo
    }
  }



}
